import { getBaseMetaTitle } from '@/environments'

const News = () => import('./Main')

const route = {
  path: '/news',
  name: 'news',
  meta: {
    title: `News - ${getBaseMetaTitle}`
  },
  component: News
}

export default route
